type Props = {
  children?: React.ReactNode;
};

const Component: React.FC<Props> = ({ children }) => (
  <div children={children} className="mx-auto max-w-[980px] px-2" />
);

export default Component;
